import { auth } from "../firebase";
import { getActiveCompany } from "./tenant";

// نداء API موثّق لنقاط اللوحة (واتساب/الإشعارات): يرفق Firebase ID token في الترويسة
// فيشتقّ الخادم الشركة منه (zero-trust). يضيف أيضاً ?company= كحزام أمان احتياطي
// (يُستخدم فقط لو غاب التوكن؛ التوكن الموثّق يفوز دائماً على الخادم).
// لا يُستخدم في المتجر العام (هناك لا يوجد مستخدم مصادَق — تُمرّر companyId في الجسم).
export async function authedFetch(url, opts = {}) {
  let token = null;
  try { token = await auth.currentUser?.getIdToken(); } catch { token = null; }
  const cid = getActiveCompany();
  const u = cid ? `${url}${url.includes("?") ? "&" : "?"}company=${encodeURIComponent(cid)}` : url;
  const headers = { ...(opts.headers || {}) };
  if (token) headers.Authorization = `Bearer ${token}`;
  return fetch(u, { ...opts, headers });
}
